import { useEffect, useRef, useState } from 'react';
import { useLocale } from '../context';

function LocaleFlag({ localeItem, className = '' }) {
  if (!localeItem?.flagIcon) return null;
  return (
    <img
      src={localeItem.flagIcon}
      alt=""
      className={`header-lang-flag-icon ${className}`.trim()}
      width={20}
      height={20}
      loading="lazy"
      decoding="async"
    />
  );
}

export default function LanguageMenu() {
  const _locale = useLocale();
  const tr = _locale.t;
  const locale = _locale.locale;
  const setLocale = _locale.setLocale;
  const locales = _locale.locales;
  const currentLocale = _locale.currentLocale;
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  return (
    <div className="header-lang-wrap" ref={ref}>
      <button
        type="button"
        className={`header-ctrl header-ctrl--lang${open ? ' is-open' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={tr('settings.language')}
      >
        <span className="header-lang-flag-wrap" aria-hidden="true">
          <LocaleFlag localeItem={currentLocale} />
        </span>
      </button>
      {open && (
        <div className="header-lang-menu" role="listbox">
          {locales.map((item) => (
            <button
              key={item.id}
              type="button"
              role="option"
              aria-selected={locale === item.id}
              className={`header-lang-menu__item${locale === item.id ? ' is-current' : ''}`}
              onClick={() => {
                setLocale(item.id);
                setOpen(false);
              }}
            >
              <span className="header-lang-flag-wrap header-lang-flag-wrap--menu" aria-hidden="true">
                <LocaleFlag localeItem={item} className="header-lang-flag-icon--menu" />
              </span>
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
